import {
  createRouter,
  createWebHistory,
  RouteRecordRaw,
  createWebHashHistory,
} from "vue-router";

import NotFound from "../views/404.vue";
import Home from "../views/Home.vue";
import Search from "../views/Search.vue";
import MediaDetail from "../views/MediaDetail.vue";
import Medias from "../views/Medias.vue";
import News from "../views/News.vue";
import NewsDetail from "../views/NewsDetail.vue";
import Page from "../views/Page.vue";
import Test from "../views/Test.vue";
import Access from "../views/Access.vue";
import CineMedias from "../views/CineMedias.vue";
import metaRobotsNavigationGuard from "./metaRobotsNavigationGuard";

const isEsInstance = process.env.VUE_APP_INSTANCE === "es";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/:catchAll(.*)",
    name: "404",
    component: NotFound,
  },
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      robots: "index, follow",
    },
  },
  {
    path: isEsInstance ? "/buscador" : "/buscador",
    name: "Search",
    component: Search,
  },
  {
    path: isEsInstance ? "/estrenos" : "/lancamentos",
    name: "Medias",
    component: Medias,
  },
  {
    path: isEsInstance ? "/estrenos/:slug" : "/lancamentos/:slug",
    name: "MediaDetail",
    component: MediaDetail,
    props: (route) => ({ slug: route.params.slug }),
  },
  {
    path: isEsInstance ? "/estrenos-en-cines" : "/estreias-nos-cinemas",
    name: "CineMedias",
    component: CineMedias,
  },
  {
    path: isEsInstance ? "/notas-de-prensa" : "/comunicados-de-imprensa",
    name: "News",
    component: News,
  },
  {
    path: isEsInstance
      ? "/notas-de-prensa/:slug"
      : "/comunicados-de-imprensa/:slug",
    name: "NewsDetail",
    component: NewsDetail,
    props: (route) => ({ slug: route.params.slug }),
  },
  {
    path: isEsInstance ? "/registro" : "/registro",
    name: "Register",
    component: Page,
    props: () => ({ slug: "register" }),
  },
  {
    path: isEsInstance ? "/sobre-filmin" : "/sobre-filmin",
    name: "About",
    component: Page,
    props: () => ({ slug: "about" }),
  },
  {
    path: isEsInstance ? "/contacto" : "/contato",
    name: "Contact",
    component: Page,
    props: () => ({ slug: "contact" }),
  },
  {
    path: "/test",
    name: "Test",
    component: Test,
    props: () => ({ slug: "test" }),
  },
  {
    path: isEsInstance ? "/acceso" : "/acesso",
    name: "Access",
    component: Access,
  },
];

const router = createRouter({
  history:
    process.env.VUE_APP_ROUTER_MODE === "hash"
      ? createWebHashHistory()
      : createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.path === from.path) {
      return; // don't change scroll if only query params change
    }
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

router.afterEach(metaRobotsNavigationGuard);

export default router;
